module.exports = __webpack_public_path__ + "prod/1.42.2/img/power2.eb9d4578.png";